import React, { useEffect, useState } from "react";
import axios, { AxiosError, AxiosResponse } from "axios";
import { WrapperLayout } from "~/Components/WrapperLayout/WrapperLayout";
import KnowledgeHubImg from "@assets/KPMG/KnowledgeHub.png";
import { Breadcrumb, Button, Card, Col, Input, Row, Typography } from "antd";
import UserIcon from "@assets/KPMG/User.svg";
import LogoMin from "@assets/KPMG/Logo.svg";
import { mockData } from "./mock";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { useQuery } from "~/Hooks/useQuery";

const getRandomText = () => {
  return `Orci convallis pulvinar urna fusce at purus neque nam leo? Suspendisse semper facilisi
  parturient sit euismod placerat. Orci ante luctus praesent torquent orci commodo aptent blandit.
  Placerat arcu dui potenti; nullam taciti taciti amet.`;
};

export const KnowledgeHub = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any>([]);
  const [searchText, setSearchText] = useState("");
  const query = useQuery();
  const queryString = query.get("q")?.toString();
  const [faqList, setFaqList] = useState<any>([]);

  useEffect(() => {
    let selectedFAQ = localStorage.getItem("selectedFAQ");
    if (queryString) {
      // setSearchText(queryString);
      addNew(queryString);
    } else if (selectedFAQ && selectedFAQ.length > 0) {
      addNew(selectedFAQ);
      localStorage.removeItem("selectedFAQ");
    }
    setFaqList(mockData.faqList);
  }, []);

  const addNew = (question: string) => {
    let tempData = [...data];
    let obj = {
      question: question,
      answer: "",
      isLoading: true,
    };
    tempData.push(obj);
    setData([...data, obj]);
    setSearchText("");
    axios
      .post(
        "/bot/api/chat",
        { text: question },
        {}
      )
      .then((res: AxiosResponse) => {
        // console.log("res", res.data);
        if (res) {
          let newData = [...tempData];
          newData[newData.length - 1].answer = res.data;
          newData[newData.length - 1].isLoading = false;
          setData(newData);
        }
      })
      .catch((err: AxiosError) => {
        console.log("err", err);
        let newData = [...tempData];
        newData[newData.length - 1].answer =
          "Oops, something went wrong. Please try again later.";
        newData[newData.length - 1].isLoading = false;
        setData(newData);
        setSearchText("");
      });
  };

  return (
    <WrapperLayout
      title={"Decarbonization Knowledge Hub"}
      text={
        "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward."
      }
      image={KnowledgeHubImg}
    >
      <>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Icon
              icon="ic:outline-home"
              height="20"
              onClick={() => navigate("/")}
              style={{
                margin: "auto",
                //   color: styles.strawberry,
                cursor: "pointer",
              }}
            />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => navigate("/knowledge-hub")}>Knowledge Hub</a>
          </Breadcrumb.Item>
        </Breadcrumb>
      </>
      <Row>
        <Col span={4}></Col>
        <Col span={16} style={{ marginBottom: 20 }}>
          <Row>
            {data &&
              data.map((item: any) => (
                <Col span={24}>
                  <div>
                    <Row>
                      <Col span={6}></Col>
                      <Col span={18}>
                        {/* <Fade direction="right" triggerOnce> */}
                        <div style={{ display: "flex", marginBottom: 10 }}>
                          <div
                            style={{
                              background: "#003087",
                              padding: "12px 24px",
                              color: "#fff",
                              borderTopLeftRadius: 20,
                              borderTopRightRadius: 20,
                              borderBottomLeftRadius: 20,
                              display: "flex",
                              width: "100%",
                              alignItems: "flex-end",
                            }}
                          >
                            <div className="textSmall">{item.question}</div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-end",
                              marginLeft: 10,
                            }}
                          >
                            <img src={UserIcon} style={{ maxWidth: 20 }} />
                          </div>
                        </div>
                        {/* </Fade> */}
                      </Col>
                    </Row>
                    <Row>
                      <Col span={18}>
                        {/* <Fade direction="left" triggerOnce> */}
                        <div style={{ display: "flex", marginBottom: 20 }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-end",
                              marginRight: 10,
                            }}
                          >
                            <img src={LogoMin} style={{ maxWidth: 48 }} />
                          </div>

                          <div
                            style={{
                              background: "#fff",
                              padding: "12px 24px",
                              boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.16)",
                              borderTopRightRadius: 20,
                              borderBottomRightRadius: 20,
                              borderBottomLeftRadius: 20,
                              display: "flex",
                              width: "100%",
                              alignItems: "flex-end",
                            }}
                          >
                            {item.isLoading && (
                              <Icon
                                icon="eos-icons:three-dots-loading"
                                color="#29256e"
                                fontSize={24}
                              />
                            )}
                            {!item.isLoading && (
                              <div style={{ fontSize: 14, fontWeight: 400 }}>
                                <Fade cascade damping={0.04} triggerOnce>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.answer,
                                    }}
                                    className="white-space-pre-line"
                                  ></div>
                                </Fade>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* </Fade> */}
                      </Col>
                      <Col span={6}></Col>
                    </Row>
                  </div>
                </Col>
              ))}
            <Col span={24}>
              <div style={{ display: "flex" }}>
                <div style={{ paddingTop: 0, width: "100%" }}>
                  <div style={{ marginTop: 20 }}>
                    <div style={{ display: "flex" }}>
                      <Input
                        placeholder="Ask AI to find anything"
                        style={{ height: 42 }}
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                        }}
                        onPressEnter={(e) => addNew(searchText)}
                      />
                      <Button
                        type="primary"
                        className="btn-primary"
                        style={{
                          height: 42,
                          borderRadius: "24 !important",
                          marginLeft: -50,
                          minWidth: 100,
                        }}
                        onClick={() => addNew(searchText)}
                      >
                        ASK
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col span={24} style={{ paddingTop: 20, paddingBottom: 20 }}>
              <Typography.Title level={4}>
                Frequently Asked Questions
              </Typography.Title>
              {faqList.map((item: any, index: number) => {
                return (
                  <div style={{ borderBottom: "1px solid #d9d9d9" }}>
                    <Row
                      style={{
                        paddingTop: 10,
                        paddingBottom: 10,
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        addNew(item.question);
                      }}
                    >
                      <Col span={2}>
                        <Typography.Text
                          className="mb-0"
                          style={{
                            color: "#003087",
                            paddingLeft: 20,
                            fontSize: 14,
                          }}
                        >
                          {item.sNo}
                        </Typography.Text>
                      </Col>
                      <Col span={20}>
                        <Typography.Text
                          className="mb-0"
                          style={{ color: "#003087", fontSize: 14 }}
                        >
                          {item.question}
                        </Typography.Text>
                      </Col>
                      <Col
                        span={2}
                        style={{
                          paddingRight: 20,
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Icon
                          icon={"uis:angle-right"}
                          style={{
                            fontSize: 24,
                            color: "#003087",
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </Col>
          </Row>
          <Row
            gutter={[32, 32]}
            style={{ paddingTop: 20, paddingBottom: 20, textAlign: "center" }}
          >
            <Col span={8}>
              {/* 003087 */}
              <div style={{ height: "100%" }}>
                <Card
                  style={{
                    background: "#003087",
                    borderRadius: 10,
                    height: "100%",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => navigate("/page/coming-soon")}
                >
                  <Typography.Text
                    style={{ fontSize: 16, fontWeight: 500, color: "#fff" }}
                  >
                    Standardise Project Documentation
                  </Typography.Text>
                </Card>
              </div>
            </Col>
            <Col span={8}>
              <div style={{ height: "100%" }}>
                <Card
                  onClick={() => navigate("/page/coming-soon")}
                  style={{
                    background: "#003087",
                    borderRadius: 10,
                    cursor: "pointer",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography.Text
                    style={{ fontSize: 16, fontWeight: 500, color: "#fff" }}
                  >
                    Policy, Regulatory and Institutional Environment
                  </Typography.Text>
                </Card>
              </div>
            </Col>
            <Col span={8}>
              <div style={{ height: "100%" }}>
                <Card
                  style={{
                    background: "#003087",
                    borderRadius: 10,
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/page/coming-soon")}
                >
                  <Typography.Text
                    style={{ fontSize: 16, fontWeight: 500, color: "#fff" }}
                  >
                    Sustainable Finance Framework​
                  </Typography.Text>
                </Card>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={4}></Col>
      </Row>
    </WrapperLayout>
  );
};
